import React, {useState} from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiMenu, FiX, FiHome} = FiIcons;

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  
  const menuItems = [
    {name: 'Startseite', href: '#/', icon: FiHome},
    {name: 'Lexware ABC', href: '#/lexware-abc'},
    {name: 'Integrationen', href: '#/integrationen'},
    {name: 'Über mich', href: '#/ueber-mich'},
  ];

  return (
    <nav className="bg-[#F3F1EE] shadow-sm border-b border-gray-200 sticky top-0 z-40">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <motion.a 
            href="#/" 
            whileHover={{scale: 1.05}} 
            className="flex items-center space-x-3"
          >
            <img 
              src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758484014539-logo%20freigestellt%20Smarte%20buchhaltung.png" 
              alt="Smarte Buchhaltung Online Logo" 
              className="h-10 w-auto"
            />
            <span className="text-xl font-bold text-[#1A1A1A]">
              Smarte Buchhaltung. <span className="text-[#E30613]">Online.</span>
            </span>
          </motion.a>
          
          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            {menuItems.map((item) => (
              <motion.a
                key={item.name}
                href={item.href}
                whileHover={{scale: 1.05}}
                className="text-[#1A1A1A] hover:text-red-500 font-medium transition-colors duration-200"
              >
                {item.name}
              </motion.a>
            ))}
            <motion.a 
              href="https://nextcloud.managershop.com/index.php/apps/appointments/pub/Gb05r41McyYVyGQE/form" 
              target="_blank" 
              rel="noopener noreferrer"
              whileHover={{scale: 1.05}} 
              whileTap={{scale: 0.95}}
              className="bg-[#E30613] hover:bg-[#C10511] text-white px-4 py-2 rounded-lg font-semibold transition-all duration-300"
            >
              Gespräch vereinbaren
            </motion.a>
          </div>
          
          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsOpen(!isOpen)} 
            className="md:hidden p-2 rounded-lg text-[#1A1A1A] hover:text-red-500 hover:bg-gray-100"
          >
            <SafeIcon icon={isOpen ? FiX : FiMenu} className="text-xl" />
          </button>
        </div>
        
        {/* Mobile Menu */}
        {isOpen && (
          <motion.div 
            initial={{opacity: 0, y: -20}} 
            animate={{opacity: 1, y: 0}} 
            className="md:hidden py-4 border-t border-gray-200"
          >
            <div className="flex flex-col space-y-3">
              {menuItems.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  onClick={() => setIsOpen(false)}
                  className="text-[#1A1A1A] hover:text-red-500 font-medium py-2 px-4 rounded-lg hover:bg-gray-100 transition-colors duration-200"
                >
                  {item.name}
                </a>
              ))}
              <a 
                href="https://nextcloud.managershop.com/index.php/apps/appointments/pub/Gb05r41McyYVyGQE/form" 
                target="_blank" 
                rel="noopener noreferrer"
                onClick={() => setIsOpen(false)}
                className="bg-[#E30613] hover:bg-[#C10511] text-white px-4 py-2 rounded-lg font-semibold text-center transition-all duration-300"
              >
                Gespräch vereinbaren
              </a>
            </div>
          </motion.div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;